{
	"ariaResetFilters": "Reset Filters",
	"filmstripPhotos": "Filmstrip ({{length}} photos)",
	"noPhotosMatching": "No photos matching selected filters",
	"resetFilters": "Reset Filters"
}
